<template>
  <main :data-testid="testId" class="min-h-screen bg-slate-950 text-slate-900">
    <section class="mx-auto flex min-h-screen max-w-4xl items-center justify-center px-6 py-12">
      <div class="w-full max-w-2xl rounded-4xl bg-white p-8 shadow-2xl ring-1 ring-slate-200 sm:p-10">
        <p v-if="eyebrow" class="text-sm font-semibold tracking-[0.24em] text-slate-500 uppercase">
          {{ eyebrow }}
        </p>
        <h1 class="mt-4 text-4xl font-bold tracking-tight text-slate-950 sm:text-5xl">
          {{ title }}
        </h1>
        <p class="mt-4 text-lg leading-8 text-slate-600">
          {{ description }}
        </p>

        <div v-if="$slots.default" class="mt-8 border-t border-slate-200 pt-6">
          <slot />
        </div>

        <div v-if="$slots.actions" class="mt-8 flex flex-wrap gap-3">
          <slot name="actions" />
        </div>
      </div>
    </section>
  </main>
</template>

<script setup lang="ts">
defineProps<{
  description: string;
  eyebrow?: string;
  testId?: string;
  title: string;
}>();
</script>
